module.exports = __webpack_public_path__ + "img/cross-boards.525bd431.svg";